(function () {
  function init() {
    var btn    = document.getElementById('mh-menu-toggle');
    var drawer = document.getElementById('mh-menu-drawer');
    if (!btn || !drawer) return;

    var header   = document.querySelector('.mh-header');
    var isStatic = header && header.getAttribute('data-mh-static') === 'true';

    btn.addEventListener('click', function () {
      var open = !document.body.classList.contains('mh-menu-open');
      if (open && isStatic) {
        // En static (product page) el header puede haber scrolleado fuera
        // de la viewport — forzamos scroll a top para que el drawer caiga
        // alineado con el nav. En fixed no hace falta y respeta la posición
        // del usuario.
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
      document.body.classList.toggle('mh-menu-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('mh-menu-open')) {
        btn.click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
